import { FilterPanelBody } from './filter-panel-body'
import styles from './filter-sidebar.module.scss'
import { ReactElement } from 'react'

/**
 * Always-visible, non-collapsible filter rail (GH-754) — shown from the `lg` breakpoint up, where
 * the 420px rail fits beside the content. Below `lg` it's hidden (`d-none d-lg-block`) and the same
 * panel is reached via the MobileFilters bottom sheet. Contents live in FilterPanelBody so both
 * stay identical.
 */
export const FilterSidebar = (): ReactElement => {
  return (
    <aside className={`d-none d-lg-block ${styles.sidebarContainer}`}>
      <div className={`d-flex flex-column justify-content-between ${styles.sidebar}`}>
        <FilterPanelBody />
      </div>
    </aside>
  )
}
